import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

export default function PaymentModal(props) {
    const {
        isOpen,
        type,
        title,
        message,
        onConfirm,
        onClose
    } = props
    const [disabled, setDisabled] = useState(false)
    const { t } = useTranslation()
    const modalId = "paymentModal"

    const getModalInstance = async () => {
        const { Modal } = await import("bootstrap")
        const modalElement = document.getElementById(modalId)
        if (!modalElement) return null
        
        // Get existing instance or create new one
        let modalInstance = Modal.getInstance(modalElement)
        if (!modalInstance) {
            modalInstance = new Modal(modalElement)
        }
        return modalInstance
    }

    const modalHandleChange = async () => {
        const modal = await getModalInstance()
        if (!modal) return
        
        if (isOpen) {
            modal.show()
        } else {
            modal.hide()
        }
    }

    const handleConfirm = () => {
        setDisabled(true)
        if (onConfirm) onConfirm()
        setTimeout(() => {
            setDisabled(false)
        }, 2000)
    }

    const handleClose = async () => {
        // Hide modal first via Bootstrap
        const modal = await getModalInstance()
        if (modal) {
            modal.hide()
        }
        // Then call the onClose callback
        if (onClose) onClose()
    }

    useEffect(() => {
        modalHandleChange()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen])

    // Reset disabled state when modal closes
    useEffect(() => {
        if (!isOpen) {
            setDisabled(false)
        }
    }, [isOpen])

    const getIcon = () => {
        switch (type) {
            case 'success':
                return <i className="fa-solid fa-circle-check text-success" style={{ fontSize: "48px" }}></i>
            case 'error':
                return <i className="fa-solid fa-circle-xmark text-danger" style={{ fontSize: "48px" }}></i>
            case 'confirm':
                return <i className="fa-solid fa-circle-question text-warning" style={{ fontSize: "48px" }}></i>
            case 'alert':
            default:
                return <i className="fa-solid fa-circle-info text-primary" style={{ fontSize: "48px" }}></i>
        }
    }

    return (
        <div
            className="modal fade"
            id={modalId}
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex={-1}
            aria-labelledby="paymentModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="paymentModalLabel">
                            {title || t("alertTitle")}
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={handleClose}
                        />
                    </div>
                    <div className="modal-body text-center">
                        <div style={{ marginBottom: "15px" }}>
                            {getIcon()}
                        </div>
                        <div>{message}</div>
                    </div>
                    <div className="modal-footer justify-content-center">
                        {type === 'confirm' ? (
                            <>
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={handleClose}
                                >
                                    {t("cancelBtn") || "ยกเลิก"}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    disabled={disabled}
                                    onClick={handleConfirm}
                                >
                                    {t("confirmBtn")}
                                </button>
                            </>
                        ) : (
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleClose}
                            >
                                {t("closeModal") || "ปิด"}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
